<script>
import { Popup } from 'bxs-ui-vue'
import * as CM from 'common/js/common'
const LS_INVITATION = 'WeiyiStat_pb_invitation'
const NG_TIME = 1000 * 60 * 60 * 24 * 30 // 1月

export default {
  name: 'ScreenDriver',
  components: {
    [Popup.name]: Popup,
  },
  data() {
    return {
      isShow: false,
    }
  },
  created() {
    this.firstView = true
    this.isShow = this.checkAdvertDisplay()
  },
  methods: {
    checkAdvertDisplay() {
      const { firstView } = this
      if (!firstView) return false
      let lastInvitation = CM.getLocalStorage(LS_INVITATION)
      if (lastInvitation) return false
      this.firstView = false
      CM.setLocalStorage(LS_INVITATION, true, NG_TIME)
      return true
    },
  },
}
</script>
<template>
  <bxs-popup v-model="isShow" class="invitation-drive">
    <div class="inner" @click="isShow = false">
      <img
        class="drive-1"
        src="//media.winbaoxian.com/autoUpload/planbook/_31_b81444247dd7b52.png"
        alt=""
      >
      <img
        class="drive-2"
        src="//media.winbaoxian.com/autoUpload/planbook/_6_e3ad0dc515ee1e6.png"
        alt=""
      >
    </div>
  </bxs-popup>
</template>
<style scoped>
@import 'variable';
.invitation-drive {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  .inner {
    width: 100%;
    height: 100%;
  }
  .drive-1 {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 4.8rem;
  }
  .drive-2 {
    position: absolute;
    bottom: 0;
    bottom: constant(safe-area-inset-bottom);
    bottom: env(safe-area-inset-bottom);
    left: 1.5rem;
    width: 4.65rem;
  }
}
</style>
